module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0084.jpg?v=2ee0fd78";